import React from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import RequestMain from './components/RequestMain';
import RequestDocuments from './components/RequestDocuments';
import RequestEmails from './components/RequestEmails';
import RequestActivities from './components/RequestActivities';
import RequestHistory from './components/RequestHistory';
import RequestJob from './components/RequestJob';
import RequestSearch from './components/RequestSearch';
import MyJobs from './components/MyJobs';
import RequestResult from './components/RequestResult';
import RedirectTo from './components/RedirectTo';
import LogSearch from './components/LogSearch';
import RequestPrices from './components/RequestPrices';
import ObjectPage from './components/ObjectPage';
import Division from './components/Division';
import { useState } from 'react';
import AISContext from './context/aisContext';
import { useEffect } from 'react';
import Comm from './comm/comm';
import Tools from './tools/tools';
import Vacations from './components/Vacations';

const App = props => {
    let [aisContext, setAISContext] = useState({
        divisions: []
    });



    useEffect(() => {
        Comm.Instance().get(`UserDivision`).then(result => {
            aisContext.divisions = result.data;
            setAISContext({ ...aisContext });

        }).catch(error => Tools.ProcessError(error))
        
    }, [])

    console.log("aiscontext", aisContext);

    return (

        <AISContext.Provider value={{ aisContext, setAISContext }}>

            <Layout>
                <Route path='/' component={MyJobs} exact />
                <Route path='/RequestMain' component={RequestMain} exact />
                <Route path='/RequestMain/:requestId' component={RequestMain} exact />
                <Route path='/RequestSearchPage' component={RequestSearch} />
                <Route path='/requestDocuments' component={RequestDocuments} />
                <Route path='/RequestEmails' component={RequestEmails} />
                <Route path='/RequestActivities' component={RequestActivities} />
                <Route path='/RequestHistory' component={RequestHistory} />
                <Route path='/RequestJob/:jobId' component={RequestJob} />
                <Route path='/MyJobs' component={MyJobs} />
                <Route path='/RequestResult' component={RequestResult} />
                <Route path='/RedirectTo/:path' component={RedirectTo} />
                <Route path='/RequestPrices' component={RequestPrices} />
                <Route path='/LogSearch' component={LogSearch} />
                <Route path='/ObjectPage' component={ObjectPage} exact />
                <Route path='/ObjectPage/:requestId' component={ObjectPage} exact />
                <Route path='/DivisionPage' component={Division} exact />
                <Route path='/Vacations' component={Vacations} exact />

            </Layout>

        </AISContext.Provider>
    )



}

export default App;
